import React, { Component } from 'react';
import PropTypes from 'prop-types'
import moment from 'moment';

export const FORMAT_DEFAULT = 'L';

export default class DateFormat extends Component {
  static propTypes = {
    date: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    format: PropTypes.string
  };

  render() {
    const { date, format, ...rest } = this.props;
    const dateMoment = moment(date);

    return (
      <span {...rest}>{ dateMoment.isValid() ? dateMoment.format(format || FORMAT_DEFAULT) : '—' }</span>
    );
  }
}
